// extracted by mini-css-extract-plugin
export default {"cls1":"StyledComponents-AppContainer_cls1__Oiqs6","cls2":"StyledComponents-AppContainer_cls2__c3Wwf StyledComponents-AppContainer_cls1__Oiqs6"};